document.addEventListener('click', e => {
    if (!e.target.matches('[data-behaviour="open-video"]')) return;
    const openClass = 'online-video-programme-content__video-content-row--open';
    const answer = e.target.closest('.online-video-programme-content__video-content-row');
    const hasClass = answer.classList.contains(openClass);

    answer.classList[hasClass ? 'remove' : 'add'](openClass);
});